<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import IconEye from '@/components/icons/Eye';
import IconMars from '@/components/icons/Mars';
import IconVenus from '@/components/icons/Venus';
import IconVacation from '@/components/icons/Vacation';
import IconPlus from '@/components/icons/Plus';
import service from './service';

export default {
  pageTitle: 'Список сотрудников',
  async prefetchData () {
    if (!this.hasReadPermission) {
      return;
    }

    this.isFetching = true;

    this.list = await service.getList();

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      list: [],
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.WORKER_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.WORKER_WRITE);
    },
    hasLogWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_WRITE);
    },
  },
  methods: {
    handleChildrenViewClose () {
      this.$_setTitle();
    },
    async handleDataUpdate () {
      this.list = await service.getList();
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, list } = this;

    return (
      <div>
        <u-title class="page-header">
          <span>
            Список сотрудников
          </span>

          <span class={$style.actions}>
            {this.hasLogWritePermission && (
              <router-link
                class="u-btn u-btn_outline u-btn_primary u-btn_square"
                to="/workers/vacation"
              >
                <IconVacation />
              </router-link>
            )}
            {this.hasWritePermission && (
              <router-link
                class="u-btn u-btn_outline u-btn_primary u-btn_square"
                to="/workers/create"
              >
                <IconPlus />
              </router-link>
            )}
          </span>
        </u-title>

        <u-table>
          {list.map(worker => (
            <u-tr key={worker.id}>
              <u-td>
                <router-link to={`/workers/${worker.id}`}>
                  {worker.name}
                </router-link>
              </u-td>
              <u-td>
                {worker.department.id ? (
                  <span class={$style.workerDepartment}>
                    <span
                      class={$style.workerDepartmentColor}
                      style={{ color: worker.department.color }}
                    />
                    {worker.department.name}
                  </span>
                ) : (
                  <span class={$style.muted}>
                    не указан
                  </span>
                )}
              </u-td>
              <u-td width="1">
                {worker.track ? (
                  <IconEye />
                ) : null}
              </u-td>
              <u-td width="1">
                {(worker.sex === 'm') && (
                  <IconMars />
                )}
                {(worker.sex === 'f') && (
                  <IconVenus />
                )}
              </u-td>
            </u-tr>
          ))}
        </u-table>

        <router-view
          onClose={this.handleChildrenViewClose}
          onDataupdate={this.handleDataUpdate}
        />
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.worker {
  &Department {
    align-items: center;
    display: flex;

    &Color {
      background-color: currentColor;
      border-radius: 50%;
      display: inline-block;
      font-size: .75em;
      height: 1em;
      margin-right: .75em;
      width: 1em;
    }
  }
}

.muted {
  color: $color-gray;
}

.actions {
  margin-left: auto;

  & > * + * {
    margin-left: .5em;
  }
}
</style>
